import { AnimatePresence } from 'framer-motion';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { Portal } from '../../Portal/src/Portal.js';
import modules_2b902d32 from '../styles/Notifications.module.less.js';
import { Notification } from './Notification.js';
import NotificationManager from './NotificationManager.js';

/**
 * @description Display a notification message globally
 *
 * @component
 * @example
 * ```jsx
 * <Notifications />
 * ```
 */
const Notifications = React.memo((props) => {
    const { className, ...restProps } = props;
    const cx = useStyles(modules_2b902d32);
    const [notifications, setNotifications] = React.useState([]);
    const handleStoreChange = React.useCallback((items) => {
        setNotifications(items);
    }, []);
    React.useEffect(() => {
        NotificationManager.addChangeListener(handleStoreChange);
        return () => {
            NotificationManager.removeChangeListener(handleStoreChange);
        };
    }, [handleStoreChange]);
    React.useEffect(() => {
        setNotifications(NotificationManager.notifications);
    }, []);
    const handleClose = React.useCallback((id) => {
        NotificationManager.remove(id);
    }, []);
    const items = React.useMemo(() => notifications.map((notification) => (React.createElement(Notification, { key: notification.id, ...notification, onClose: handleClose }))), [handleClose, notifications]);
    return (React.createElement(Portal, null,
        React.createElement("div", { "data-qa": "Notifications", className: cx(className, 'container'), ...restProps },
            React.createElement(AnimatePresence, null, items))));
});
Notifications.displayName = 'Notifications';

export { Notifications };
//# sourceMappingURL=Notifications.js.map
